import {SmmAccountsData} from '../types/socialMediaMonitoring';
import {fetchRest} from '../helpers/fetchRest';
import {useQuery} from '@tanstack/react-query';
import utils from '../helpers/utils';

/**
 * Fetches socialMediaMonitoring data
 * @param {string} userId - The user ID to fetch data for.
 * @returns {isError, error, isLoading, isSuccess, data} | {}
 **/
export const useSmmAccounts = (userId: string) => {
  const url = utils.getSmmAccounts(userId);
  const {isError, error, isLoading, isSuccess, data, refetch} = useQuery<SmmAccountsData>({
    queryKey: ['smmAccounts', userId],
    queryFn: () =>
      fetchRest(url, {
        method: 'GET',
        headers: {Accept: 'application/json'},
      }),
  });

  return {isError, error, isLoading, isSuccess, data, refetch};
};
